import { getApolloClient } from './graphql'

export const apolloClient = getApolloClient()
